import type { GameTextureManifestEntry } from './resolveGameAssetUrl';

/** Bounds metadata-driven artwork and procedural candidate allocation at camera zoom 1. */
export const MAX_SPRITE_PRESENTATION_EXTENT_PX = 2048;

/** Invalid optional metadata must never displace legacy artwork. */
export function spritePresentation(entry: GameTextureManifestEntry | undefined, width: number, height: number) {
  const p = entry?.presentation;
  if (!p || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
  const b = p.bodyBoundsPx, c = p.groundContactPx;
  if (!b || !c || ![b.x, b.y, b.width, b.height, c.x, c.y, p.displayHeightPx].every(Number.isFinite)
    || b.x < 0 || b.y < 0 || b.width <= 0 || b.height <= 0 || p.displayHeightPx <= 0
    || b.x + b.width > width || b.y + b.height > height
    || c.x < 0 || c.y < 0 || c.x > width || c.y > height) return null;
  const scale = p.displayHeightPx / b.height;
  if (!Number.isFinite(scale) || !Number.isFinite(width * scale) || !Number.isFinite(height * scale)
    || width * scale > MAX_SPRITE_PRESENTATION_EXTENT_PX
    || height * scale > MAX_SPRITE_PRESENTATION_EXTENT_PX) return null;
  return { scale, anchorX: c.x / width, anchorY: c.y / height };
}

export function spriteIntersectsViewport(x: number, y: number, width: number, height: number,
  scale: number, anchorX: number, anchorY: number, minX: number, maxX: number, minY: number, maxY: number) {
  return x - anchorX * width * scale <= maxX && x + (1 - anchorX) * width * scale >= minX
    && y - anchorY * height * scale <= maxY && y + (1 - anchorY) * height * scale >= minY;
}
